export function findCaseIdForEventId(state, eventId) {
  if (state.entities) state = state.entities.calendar;
  const caseIds = Object.keys(state);
  let i = 0;
  for (i = 0; i < caseIds.length; i++) {
    if (state[caseIds[i]][eventId]) break;
  }
  if (i === caseIds.length) return null;
  return caseIds[i];
}

export function getHashOfAllEventsByEventId(state) {
  if (state.entities) state = state.entities.calendar;
  const eventsByCase = state;
  let events = {};
  Object.keys(eventsByCase).forEach(caseId => {
    const eventsForCase = eventsByCase[caseId];
    events = {
      ...events,
      ...eventsForCase,
    };
  });
  return events;
}

export function getArrayOfAllEventIds(state) {
  if (state.entities) state = state.entities.calendar;
  let eventIds = [];
  Object.keys(state).forEach(caseId => {
    eventIds = eventIds.concat(Object.keys(state[caseId]));
  });
  return eventIds;
}

export function getCaseEventByEventIdInState(state, eventId) {
  if (state.entities) state = state.entities.calendar;
  const caseId = findCaseIdForEventId(state, eventId);
  const events = state[caseId];
  return events && events[eventId];
}

export function getCaseEventByCaseIdAndEventIdInState(state, caseId, eventId) {
  if (state.entities) state = state.entities.calendar;
  if (!caseId) return getCaseEventByEventIdInState(state, eventId);

  return state[caseId] && state[caseId][eventId];
}
